import { BCMSDefaultModel } from "@bcm-dev/bcms-vite";
import BillerSearchField from "compid/pages/SearchBillerPage/components/BillerSearchField";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import UIButton from "compid/ui/UIButton";
import "./styles.css";

import { BCMSRecord, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultBiller, getWorkflowSteps } from "compid/workflows/AddBiller";
import { AddBiller, Biller } from "model";

export default function SearchBillerPage(props) {
  // Initalize the workflowStep
  const workflowStep = useWorkflowStep(getDefaultBiller, getWorkflowSteps);
  // Initalize classes with the globalController
  BCMSRecord.globalControllerFor([ Biller, AddBiller ], workflowStep.globalController);

  const biller = workflowStep.read("biller");
 
  const updateBillerName = value => workflowStep.update(["biller", "name"], value);
 
  const submit = evt => {
    // Get the biller with the same name
    const setBiller = AddBiller.initAll().find(item => item.name === biller.name);
    const defaultBiller = BCMSDefaultModel.biller();

    // If a biller has been selected from the dropdown, update state and go to next step
    if(setBiller !== undefined) {
      setBiller.number = "";
      setBiller.nickname = "";
      setBiller.zip = "";

      workflowStep.update(["biller"], setBiller);

      try {
        workflowStep.workflow.nextStep(workflowStep.getStepState);
      } catch(error) {
        workflowStep.navigate(`/addBillerWorkflow/${ workflowStep.currentStep + 1 }`, { state: workflowStep.getStepState });
      }
    } 
    else if(biller.name) {
      if(biller.name.length > 0) {
        workflowStep.navigate("/addBillerLongWorkflow/addCompany", { "state" : { "name" : biller.name } });
      }
    } else {
      workflowStep.navigate("/addBillerLongWorkflow/addCompany", { "state" : { "name" : defaultBiller.name } });
    }
  };
  
  const cancel = () => workflowStep.navigate("/payBills");

  return (
    <PageView className="search-biller-page">
      <p className="page-sub-header semi-bold-text">ADD BILLER</p>

      <PageLayoutContainer>
        <CenterColumnContainer>
          <div className="form-group flex-container flex-vertical">
            <BillerSearchField dataPoint="biller_search_input" placeholderText="Search for a biller" value={ biller.name } onChange={ updateBillerName } />

            <ButtonContainer className="form-button-container">
              <UIButton className="secondary-button" dataPoint="cancel_search_Button" onClick={ cancel }>Cancel</UIButton>
              <UIButton className="primary-button"  dataPoint="next_search_Button" onClick={ submit }>Next</UIButton>
            </ButtonContainer>
          </div>
        </CenterColumnContainer>
      </PageLayoutContainer>
    </PageView>
  )
}
